import {useState} from 'react'
import Jumbo from '../assets/img/Jumbo.svg'
import Table from 'react-bootstrap/Table'
import footerIcons from '../assets/img/footerIcons.svg'
import {Link} from 'react-router-dom'
import {CatalogSaved} from './CatalogSaved'
import {SaveCatalog} from './SaveCatalog'
import {CatalogosConsolidadosPopup} from './CatalogosConsolidadosPopup'
import {RenombrarPopupNew} from './RenombrarPopupNew'
import {CambiarFechasPopup} from '../componentsRef/CambiarFechasPopup'

export const CataLogoResumenFooterNew = ({
	SetCatalogMove = null,
	setcombiar = null,
	setRenombrar = null,
}) => {
	const [active, setActive] = useState(false)
	const [catalogguadar, setcatalogguadar] = useState(false)
	const [guadar, setguadar] = useState(false)
	const [RenombrarPopup, setRenombrarPopup] = useState(false)
	const [CatalogosConsolidadosPopupState, setCatalogosConsolidadosPopup] =
		useState(false)
	const [Catalogoactive, setCatalogoActive] = useState(false)
	return (
		<div className='CataLogoResumenFooter'>
			{Catalogoactive && <CambiarFechasPopup setActive={setCatalogoActive} />}
			{RenombrarPopup && <RenombrarPopupNew setRenombrar={setRenombrarPopup} />}

			{catalogguadar && <CatalogSaved setActive={setcatalogguadar} />}
			{guadar && (
				<SaveCatalog setActive={setguadar} setSaved={setcatalogguadar} />
			)}
			{CatalogosConsolidadosPopupState && (
				<CatalogosConsolidadosPopup
					setCatalogosConsolidadosPopup={setCatalogosConsolidadosPopup}
				/>
			)}
			<div className='left_area'>
				<p>Cadena</p>
				<img src={Jumbo} alt='' />
			</div>
			<div className='table_area_footer_resumen'>
				<img
					src={footerIcons}
					onClick={(e) => {
						setCatalogosConsolidadosPopup(true)
					}}
					style={{
						position: 'absolute',
						right: -10,
						top: -10,
						cursor: 'pointer',
					}}
					alt=''
				/>
				<Table style={{marginTop: 10, marginBottom: 10}}>
					<tbody>
						<tr>
							<td>
								<span style={{color: '#AEB0B0', textAlign: 'left'}}>
									Resumen Canal
								</span>
								<p style={{color: '#36A7F5', textAlign: 'left'}}>Cecinas</p>
							</td>
							<td>
								<span>Volumen Act.</span>
								<p>1234,0 Ton.</p>
							</td>
							<td>
								<span>Volumen Opt.</span>
								<p>1234,0 Ton.</p>
							</td>
							<td>
								<span>Volumen Prop.</span>
								<p>1234,0 Ton.</p>
							</td>
							<td style={{borderRight: '1px solid #AEB0B0'}}>
								<span>Volumen Prop. + O.I.</span>
								<p>1234,0 Ton.</p>
							</td>
						</tr>
					</tbody>
				</Table>
				<Table>
					<tbody>
						<tr>
							<td>
								<span>Res. Op. Opt.</span>
								<p>$888.202.079</p>
							</td>
							<td>
								<span>Beneficio Opt.</span>
								<p>$12.131.464</p>
							</td>
							<td>
								<span>Res. Op. Prop.</span>
								<p>$1.036.373.566</p>
							</td>
							<td>
								<span>Beneficio Prop.</span>
								<p>$160.302.951</p>
							</td>
							<td>
								<span>Beneficio Prop. + O.I.</span>
								<p>$160.302.951</p>
							</td>
						</tr>
					</tbody>
				</Table>
			</div>

			<div>
				<button
					id='dropdown_btn'
					className={`${active && 'active'}`}
					onClick={(e) => setActive(!active)}
				>
					Gestionar Catálogo
					<svg
						width='18'
						height='18'
						viewBox='0 0 18 18'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path
							d='M13.3536 7.35355C13.5488 7.15829 13.5488 6.84171 13.3536 6.64645C13.1583 6.45118 12.8417 6.45118 12.6464 6.64645L13.3536 7.35355ZM9 11L8.64645 11.3536C8.84171 11.5488 9.15829 11.5488 9.35355 11.3536L9 11ZM5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L5.35355 6.64645ZM12.6464 6.64645L8.64645 10.6464L9.35355 11.3536L13.3536 7.35355L12.6464 6.64645ZM9.35355 10.6464L5.35355 6.64645L4.64645 7.35355L8.64645 11.3536L9.35355 10.6464Z'
							fill='white'
						/>
					</svg>
				</button>
				{active && (
					<ul>
						<li>
							<Link to='/ResumenDeCataloge'>
								<svg
									width='15'
									height='15'
									viewBox='0 0 15 15'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_2373_41839'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2373_41839)'>
										<path
											d='M4.14075 13.4531C3.7865 13.4531 3.47913 13.3229 3.21863 13.0624C2.95838 12.8021 2.82825 12.4949 2.82825 12.1406V3.39075H2.703C2.526 3.39075 2.375 3.32825 2.25 3.20325C2.125 3.07825 2.0625 2.922 2.0625 2.7345C2.0625 2.55725 2.125 2.40362 2.25 2.27362C2.375 2.14337 2.526 2.07825 2.703 2.07825H5.48438C5.48438 1.9115 5.54688 1.77087 5.67188 1.65637C5.79688 1.54162 5.94788 1.48425 6.12488 1.48425H8.8905C9.06775 1.48425 9.2215 1.54162 9.35175 1.65637C9.48175 1.77087 9.54675 1.9115 9.54675 2.07825H12.3124C12.4896 2.07825 12.6433 2.14337 12.7733 2.27362C12.9035 2.40362 12.9686 2.55725 12.9686 2.7345C12.9686 2.922 12.9035 3.07825 12.7733 3.20325C12.6433 3.32825 12.4896 3.39075 12.3124 3.39075H12.2032V12.1406C12.2032 12.4949 12.073 12.8021 11.8125 13.0624C11.552 13.3229 11.2448 13.4531 10.8907 13.4531H4.14075ZM5.48438 10.1719C5.48438 10.3489 5.5495 10.4999 5.67975 10.6249C5.81 10.7499 5.96362 10.8124 6.14062 10.8124C6.31763 10.8124 6.47125 10.7499 6.6015 10.6249C6.73175 10.4999 6.79688 10.3489 6.79688 10.1719V5.3595C6.79688 5.18225 6.73175 5.02862 6.6015 4.89862C6.47125 4.76837 6.31763 4.70325 6.14062 4.70325C5.95312 4.70325 5.79688 4.76837 5.67188 4.89862C5.54688 5.02862 5.48438 5.18225 5.48438 5.3595V10.1719ZM8.23425 10.1719C8.23425 10.3489 8.29938 10.4999 8.42963 10.6249C8.55988 10.7499 8.7135 10.8124 8.8905 10.8124C9.06775 10.8124 9.2215 10.7499 9.35175 10.6249C9.48175 10.4999 9.54675 10.3489 9.54675 10.1719V5.3595C9.54675 5.18225 9.48175 5.02862 9.35175 4.89862C9.2215 4.76837 9.06775 4.70325 8.8905 4.70325C8.703 4.70325 8.54675 4.76837 8.42175 4.89862C8.29675 5.02862 8.23425 5.18225 8.23425 5.3595V10.1719Z'
											fill='#C5C5C5'
										/>
									</g>
								</svg>
								Eliminar
							</Link>
						</li>

						<li>
							<Link
								to='/ResumenDeCataloge'
								onClick={(e) => {
									e.preventDefault()
									setCatalogoActive(true)
								}}
							>
								<svg
									width='15'
									height='15'
									viewBox='0 0 15 15'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_2564_46945'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2564_46945)'>
										<path
											d='M2.85938 14.0625C2.50512 14.0625 2.19787 13.9323 1.93762 13.6718C1.67712 13.4115 1.54688 13.1042 1.54688 12.75V3.25012C1.54688 2.89587 1.67712 2.5885 1.93762 2.328C2.19787 2.06775 2.50512 1.93762 2.85938 1.93762H3.40613V1.6095C3.40613 1.422 3.47388 1.26312 3.60938 1.13287C3.74487 1.00262 3.90112 0.9375 4.07812 0.9375C4.27612 0.9375 4.44025 1.00262 4.5705 1.13287C4.7005 1.26312 4.7655 1.422 4.7655 1.6095V1.93762H10.2345V1.6095C10.2345 1.422 10.2995 1.26312 10.4295 1.13287C10.5598 1.00262 10.7186 0.9375 10.9061 0.9375C11.0936 0.9375 11.2551 1.00262 11.3906 1.13287C11.5261 1.26312 11.5939 1.422 11.5939 1.6095V1.93762H12.1406C12.4949 1.93762 12.8021 2.06775 13.0624 2.328C13.3229 2.5885 13.4531 2.89587 13.4531 3.25012V7.9845H12.1406V5.93738H2.85938V12.75H7.70325V14.0625H2.85938ZM2.85938 4.62488H12.1406V3.25012H2.85938V4.62488ZM14.0936 10.8281L12.7343 9.453L13.1876 9C13.3126 8.8855 13.4663 8.82825 13.6485 8.82825C13.8307 8.82825 13.9791 8.8855 14.0936 9L14.547 9.453C14.672 9.5885 14.7345 9.74475 14.7345 9.92175C14.7345 10.099 14.672 10.2501 14.547 10.3751L14.0936 10.8281ZM8.7345 14.5001V13.7186C8.7345 13.6354 8.75012 13.5547 8.78137 13.4767C8.81262 13.3985 8.86462 13.3281 8.93738 13.2656L12.1406 10.047L13.5 11.4218L10.2968 14.6407C10.2343 14.7032 10.164 14.7475 10.086 14.7735C10.0077 14.7995 9.927 14.8125 9.84375 14.8125H9.06262C8.97913 14.8125 8.9035 14.7839 8.83575 14.7266C8.76825 14.6694 8.7345 14.5939 8.7345 14.5001Z'
											fill='#C5C5C5'
										/>
									</g>
								</svg>
								Cambiar Fechas
							</Link>
						</li>

						<li className='breaker'>
							<Link
								to='/ResumenDeCataloge'
								onClick={(e) => {
									e.preventDefault()

									setRenombrarPopup(true)
								}}
							>
								<svg
									width='15'
									height='16'
									viewBox='0 0 15 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_2564_46952)'>
										<mask
											id='mask0_2564_46952'
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='15'
											height='15'
										>
											<rect width='15' height='15' fill='#D9D9D9' />
										</mask>
										<g mask='url(#mask0_2564_46952)'>
											<path
												d='M5.87512 13.5626L8.4375 10.9999H12.6094C12.9636 10.9999 13.2657 11.1223 13.5157 11.367C13.7657 11.612 13.8907 11.9168 13.8907 12.2813C13.8907 12.6458 13.7657 12.9505 13.5157 13.1955C13.2657 13.4403 12.9636 13.5626 12.6094 13.5626H5.87512ZM2.4375 12.2501H3.375L9.71887 5.8905L8.78137 4.953L2.4375 11.3126V12.2501ZM12.3124 5.1405L9.53137 2.34375L10.2345 1.64063C10.4845 1.38013 10.797 1.2525 11.172 1.25775C11.547 1.263 11.8595 1.39063 12.1095 1.64063L13.047 2.59388C13.297 2.84388 13.4194 3.1485 13.4141 3.50775C13.4089 3.86725 13.2812 4.172 13.0312 4.422L12.3124 5.1405ZM1.7655 13.5626C1.578 13.5626 1.42438 13.5001 1.30463 13.3751C1.18488 13.2501 1.125 13.0939 1.125 12.9064V11.0314C1.125 10.9479 1.138 10.8671 1.164 10.7891C1.19 10.7109 1.23425 10.6405 1.29675 10.578L8.8125 3.078L11.5939 5.85938L4.09387 13.3751C4.03137 13.4376 3.961 13.4845 3.88275 13.5158C3.80475 13.547 3.72925 13.5626 3.65625 13.5626H1.7655ZM9.2655 5.42175L8.78137 4.953L9.71887 5.8905L9.2655 5.42175Z'
												fill='#C5C5C5'
											/>
										</g>
									</g>
									<defs>
										<clipPath id='clip0_2564_46952'>
											<rect
												width='15'
												height='15'
												fill='white'
												transform='translate(0 0.5)'
											/>
										</clipPath>
									</defs>
								</svg>
								Renombrar
							</Link>
						</li>

						<li>
							<Link to='/ResumenDeCataloge'>
								<svg
									width='15'
									height='16'
									viewBox='0 0 15 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_2373_41873)'>
										<mask
											id='mask0_2373_41873'
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='15'
											height='15'
										>
											<rect width='15' height='15' fill='#D9D9D9' />
										</mask>
										<g mask='url(#mask0_2373_41873)'>
											<path
												d='M8.12475 7.14075L9.62475 8.6565C9.79175 8.823 9.87775 9.01825 9.88275 9.24225C9.88825 9.46625 9.80225 9.66675 9.62475 9.84375C9.45825 10.0102 9.25775 10.0935 9.02325 10.0935C8.78875 10.0935 8.58825 10.0102 8.42175 9.84375L6.6405 8.07825C6.5575 7.99475 6.49775 7.90625 6.46125 7.81275C6.42475 7.71875 6.4065 7.6145 6.4065 7.5V4.9845C6.4065 4.7555 6.49225 4.555 6.66375 4.383C6.83575 4.211 7.0365 4.125 7.266 4.125C7.495 4.125 7.6955 4.211 7.8675 4.383C8.039 4.555 8.12475 4.7555 8.12475 4.9845V7.14075ZM7.74975 13.6252C6.38525 13.6252 5.151 13.2397 4.047 12.4687C2.943 11.6977 2.19825 10.656 1.81275 9.3435C1.72925 9.0935 1.75525 8.85925 1.89075 8.64075C2.02625 8.42175 2.219 8.2915 2.469 8.25C2.6875 8.2085 2.888 8.25275 3.0705 8.38275C3.2525 8.51325 3.38525 8.68775 3.46875 8.90625C3.79175 9.81275 4.3385 10.5392 5.109 11.0857C5.88 11.6327 6.75 11.9062 7.719 11.9062C8.927 11.9062 9.9555 11.4765 10.8045 10.617C11.6535 9.758 12.078 8.719 12.078 7.5C12.078 6.2915 11.6588 5.255 10.8203 4.3905C9.98175 3.526 8.95825 3.09375 7.74975 3.09375C6.95825 3.09375 6.2135 3.28125 5.5155 3.65625C4.8175 4.03125 4.276 4.55725 3.891 5.23425H4.8285C5.0575 5.23425 5.258 5.32025 5.43 5.49225C5.6015 5.66425 5.68725 5.86475 5.68725 6.09375C5.68725 6.32275 5.6015 6.52325 5.43 6.69525C5.258 6.86725 5.0575 6.95325 4.8285 6.95325H2.04675C1.81775 6.95325 1.61975 6.87 1.45275 6.7035C1.28625 6.5365 1.203 6.3385 1.203 6.1095V3.1875C1.203 2.9585 1.289 2.758 1.461 2.586C1.633 2.414 1.8335 2.328 2.0625 2.328C2.2915 2.328 2.492 2.414 2.664 2.586C2.836 2.758 2.922 2.9585 2.922 3.1875V3.7035C3.4635 2.9115 4.164 2.3255 5.0235 1.9455C5.883 1.565 6.79175 1.37475 7.74975 1.37475C8.58325 1.37475 9.36725 1.53375 10.1018 1.85175C10.8363 2.16925 11.4795 2.60675 12.0315 3.16425C12.5835 3.72125 13.0158 4.37225 13.3283 5.11725C13.6408 5.86175 13.797 6.65075 13.797 7.48425C13.797 8.32825 13.6408 9.1225 13.3283 9.867C13.0158 10.612 12.5835 11.263 12.0315 11.82C11.4795 12.3775 10.8388 12.8177 10.1093 13.1407C9.38025 13.4637 8.59375 13.6252 7.74975 13.6252Z'
												fill='#C5C5C5'
											/>
										</g>
									</g>
									<defs>
										<clipPath id='clip0_2373_41873'>
											<rect
												width='15'
												height='15'
												fill='white'
												transform='translate(0 0.5)'
											/>
										</clipPath>
									</defs>
								</svg>
								Resumen de Catálogo
							</Link>
						</li>
						<li className='breaker'>
							<Link to='/ResumenDeCataloge'>
								<svg
									width='15'
									height='15'
									viewBox='0 0 15 15'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_2373_41968'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2373_41968)'>
										<path
											d='M7.51575 10.1408C7.32825 10.1408 7.172 10.0783 7.047 9.95325C6.922 9.82825 6.8595 9.672 6.8595 9.4845V4.64063L5.4375 6.06263C5.302 6.18763 5.14838 6.2475 4.97663 6.24225C4.80463 6.237 4.65613 6.17188 4.53113 6.04688C4.39588 5.91138 4.32563 5.75513 4.32038 5.57813C4.31513 5.40113 4.38538 5.23963 4.53113 5.09363L7.047 2.57813C7.1095 2.51563 7.18238 2.46613 7.26563 2.42963C7.34888 2.39313 7.43225 2.37488 7.51575 2.37488C7.599 2.37488 7.67975 2.39313 7.758 2.42963C7.836 2.46613 7.90625 2.51563 7.96875 2.57813L10.5158 5.12513C10.651 5.26038 10.7186 5.414 10.7186 5.586C10.7186 5.75775 10.651 5.91138 10.5158 6.04688C10.3908 6.17188 10.237 6.23438 10.0545 6.23438C9.87225 6.23438 9.71863 6.16663 9.59363 6.03113L8.172 4.64063V9.4845C8.172 9.672 8.10688 9.82825 7.97663 9.95325C7.84638 10.0783 7.69275 10.1408 7.51575 10.1408ZM3.49988 12.8126C3.14588 12.8126 2.83863 12.685 2.57813 12.4298C2.31763 12.1745 2.18738 11.8646 2.18738 11.5001V10.0313C2.18738 9.85425 2.2525 9.70063 2.38275 9.57038C2.513 9.44013 2.66663 9.375 2.84363 9.375C3.03113 9.375 3.18738 9.44013 3.31238 9.57038C3.43738 9.70063 3.49988 9.85425 3.49988 10.0313V11.5001H11.5001V10.0313C11.5001 9.85425 11.5653 9.70063 11.6955 9.57038C11.8255 9.44013 11.9791 9.375 12.1564 9.375C12.3439 9.375 12.5001 9.44013 12.6251 9.57038C12.7501 9.70063 12.8126 9.85425 12.8126 10.0313V11.5001C12.8126 11.8646 12.6824 12.1745 12.4219 12.4298C12.1614 12.685 11.8541 12.8126 11.5001 12.8126H3.49988Z'
											fill='#C5C5C5'
										/>
									</g>
								</svg>
								Exportar Vista
							</Link>
						</li>
						<li>
							<Link
								to='/ResumenDeCataloge'
								onClick={(e) => {
									setguadar(true)
								}}
							>
								<svg
									width='15'
									height='16'
									viewBox='0 0 15 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_2373_42008)'>
										<mask
											id='mask0_2373_42008'
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='15'
											height='15'
										>
											<rect width='15' height='15' fill='#D9D9D9' />
										</mask>
										<g mask='url(#mask0_2373_42008)'>
											<path
												d='M3.03125 13.625C2.57292 13.625 2.18229 13.4635 1.85937 13.1406C1.53646 12.8177 1.375 12.4271 1.375 11.9687V3.03125C1.375 2.57292 1.53646 2.18229 1.85937 1.85937C2.18229 1.53646 2.57292 1.375 3.03125 1.375H10.1562C10.375 1.375 10.586 1.41667 10.7894 1.5C10.9923 1.58333 11.1719 1.70312 11.3281 1.85937L13.1406 3.67188C13.2969 3.82812 13.4167 4.00771 13.5 4.21062C13.5833 4.41396 13.625 4.625 13.625 4.84375V11.9687C13.625 12.4271 13.4635 12.8177 13.1406 13.1406C12.8177 13.4635 12.4271 13.625 11.9687 13.625H3.03125ZM7.5 11.4688C8.08333 11.4688 8.57812 11.2656 8.98438 10.8594C9.39062 10.4531 9.59375 9.95833 9.59375 9.375C9.59375 8.79167 9.39062 8.29688 8.98438 7.89062C8.57812 7.48438 8.08333 7.28125 7.5 7.28125C6.91667 7.28125 6.42188 7.48438 6.01562 7.89062C5.60938 8.29688 5.40625 8.79167 5.40625 9.375C5.40625 9.95833 5.60938 10.4531 6.01562 10.8594C6.42188 11.2656 6.91667 11.4688 7.5 11.4688ZM4.34375 6.46875H8.84375C9.07292 6.46875 9.26562 6.39063 9.42188 6.23438C9.57812 6.07813 9.65625 5.88542 9.65625 5.65625V4.34375C9.65625 4.11458 9.57812 3.92188 9.42188 3.76562C9.26562 3.60938 9.07292 3.53125 8.84375 3.53125H4.34375C4.11458 3.53125 3.92188 3.60938 3.76562 3.76562C3.60938 3.92188 3.53125 4.11458 3.53125 4.34375V5.65625C3.53125 5.88542 3.60938 6.07813 3.76562 6.23438C3.92188 6.39063 4.11458 6.46875 4.34375 6.46875Z'
												fill='#C5C5C5'
											/>
										</g>
									</g>
									<defs>
										<clipPath id='clip0_2373_42008'>
											<rect
												width='15'
												height='15'
												fill='white'
												transform='translate(0 0.5)'
											/>
										</clipPath>
									</defs>
								</svg>
								Guardar
							</Link>
						</li>
						<li>
							<Link
								to='/ResumenDeCataloge'
								onClick={(e) => {
									e.preventDefault()
									SetCatalogMove(true)
								}}
							>
								<svg
									width='15'
									height='16'
									viewBox='0 0 15 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_2373_42075)'>
										<mask
											id='mask0_2373_42075'
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='15'
											height='15'
										>
											<rect width='15' height='15' fill='#D9D9D9' />
										</mask>
										<g mask='url(#mask0_2373_42075)'>
											<path
												d='M2.65637 12.3125C2.38554 12.4271 2.13033 12.4035 1.89075 12.2419C1.65116 12.0806 1.53137 11.8542 1.53137 11.5625V9.42188C1.53137 9.23438 1.58866 9.07021 1.70325 8.92938C1.81783 8.78896 1.96366 8.69271 2.14075 8.64063L6.90637 7.4375L2.14075 6.23438C1.96366 6.18229 1.81783 6.08584 1.70325 5.945C1.58866 5.80459 1.53137 5.64063 1.53137 5.45313V3.34375C1.53137 3.05209 1.65116 2.82542 1.89075 2.66375C2.13033 2.5025 2.38554 2.47917 2.65637 2.59375L12.3595 6.70313C12.6928 6.84896 12.8595 7.09896 12.8595 7.45313C12.8595 7.80729 12.6928 8.05729 12.3595 8.20313L2.65637 12.3125Z'
												fill='#C5C5C5'
											/>
										</g>
									</g>
									<defs>
										<clipPath id='clip0_2373_42075'>
											<rect
												width='15'
												height='15'
												fill='white'
												transform='translate(0 0.5)'
											/>
										</clipPath>
									</defs>
								</svg>
								Mover
							</Link>
						</li>
					</ul>
				)}
			</div>
		</div>
	)
}
